/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Reason_Subscriptionrenewal1Inputs */

const zh_usage_reason_subscriptionrenewal1 = /** @type {(inputs: Usage_Reason_Subscriptionrenewal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`订阅月度积分`)
};

const en_usage_reason_subscriptionrenewal1 = /** @type {(inputs: Usage_Reason_Subscriptionrenewal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly subscription credits`)
};

const es_usage_reason_subscriptionrenewal1 = /** @type {(inputs: Usage_Reason_Subscriptionrenewal1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créditos mensuales de suscripción`)
};

/**
* | output |
* | --- |
* | "Monthly subscription credits" |
*
* @param {Usage_Reason_Subscriptionrenewal1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const usage_reason_subscriptionrenewal1 = /** @type {((inputs?: Usage_Reason_Subscriptionrenewal1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Reason_Subscriptionrenewal1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_usage_reason_subscriptionrenewal1(inputs)
	if (locale === "en") return en_usage_reason_subscriptionrenewal1(inputs)
	return es_usage_reason_subscriptionrenewal1(inputs)
});
export { usage_reason_subscriptionrenewal1 as "usage_reason_subscriptionRenewal" }